<template>
  <v-container class="pa-0 ma-0">
    <v-dialog
      v-model="compositeDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="730"
    >
      <v-card class="pa-5">
        <v-container
          class="pa-0 d-flex justify-space-between mb-5"
          :class="{ 'pa-5': isMobile }"
        >
          <v-card-text class="text-h5 pa-0">{{ $t("severance_Calc") }}</v-card-text>
          <v-icon class="pa-0 ma-0" @click="close()">mdi-close</v-icon>
        </v-container>
        <v-container
          class="pa-0 d-flex justify-space-between mb-3"
          :class="{ 'pa-5': isMobile }"
        >
          <v-tabs
            v-model="activeTab"
            background-color="transparent"
            color="primary"
            class="ma-0 pa-0 custom-annual-tabs"
          >
            <v-tab value="tab1">
              {{ $t("end_of_the_year") }}
            </v-tab>
            <v-tab value="tab2">
              {{ $t("end_of_the_month") }}
            </v-tab>
            <v-tab value="tab3">
              {{ $t("fixed_number_of_day") }}
            </v-tab>
          </v-tabs>
          <v-text-field
            v-if="isTab3Active"
            v-model="fixedNumberOfDay"
            :label="$t('fixed_number_of_day')"
            outlined
            clearable
            dense
            class="pa-0 ma-0"
          />
          <v-btn
            outlined
            @click="openNewSaleryFactor"
            class="ms-2 pa-0"
            color="primary"
            height="32"
          >
            {{ $t("severance_Calc") }}
          </v-btn>
        </v-container>
        <div class="table-wrapper">
          <v-progress-linear
            v-if="tableLoading"
            indeterminate
            color="primary"
            height="3"
            class="table-loading-line"
          />
          <v-data-table
            :headers="compositeTableHeaders"
            :items="filteredItems"
            :items-per-page="-1"
            hide-default-footer
            :height="isMobile || isTablet ? 265 : 265"
            fixed-header
            class="composite"
            :class="{ 'ma-5': isMobile }"
          >
            <template v-slot:item.id="{ item, index }">
              <v-card-text class="pa-0 text-caption">
                {{ index + 1 }}
              </v-card-text>
            </template>
            <template v-slot:item.name="{ item }">
              <v-card-text v-if="item.name != null" class="pa-0 text-caption">
                {{ $t(item.name) }}
              </v-card-text>
              <v-card-text
                v-if="item.level == null"
                class="pa-0 text-caption text-disable secondary--text"
              >
                {{ $t("haveNot") }}
              </v-card-text>
            </template>
            <template v-slot:item.tax_type="{ item }">
              <v-card-text v-if="item.tax_type != null" class="pa-0 text-caption">
                {{ $t(item.tax_type) }}
              </v-card-text>
              <v-card-text
                v-if="item.tax_type == null"
                class="pa-0 text-caption text-disable secondary--text"
              >
                {{ $t("haveNot") }}
              </v-card-text>
            </template>
            <template v-slot:item.incentive_benefit="{ item }">
              <div class="checkbox-cell">
                <v-checkbox
                  class="mr-2"
                  v-model="item.incentive_benefit"
                  dense
                  hide-details
                />
              </div>
            </template>
            <template v-slot:item.type="{ item }">
              <div class="table-input">
                <v-text-field
                  v-if="item.type != null"
                  v-model="Eid"
                  dense
                  hide-details
                  outlined
                  class="table-text-field"
                />
                <v-card-text
                  v-else
                  class="pa-0 text-caption text-disable secondary--text"
                >
                  {{ $t("haveNot") }}
                </v-card-text>
              </div>
            </template>

            <!-- <template v-slot:item.status="{ item }">
              <v-card-text class="pa-0 ma-0">
                <v-container
                  v-if="normalizeStatus(item.status) === 'default'"
                  class="pa-0 ma-0 d-flex justify-center aling-center wrapper"
                >
                  <v-btn dense outlined color="secondary" height="22">
                    {{ $t("default_system") }}</v-btn
                  >
                </v-container>
                <v-container
                  v-else
                  class="pa-0 ma-0 d-flex justify-center aling-center wrapper"
                >
                  <div
                    v-for="(option, index) in Options"
                    :key="index"
                    :class="{ active: normalizeStatus(item.status) === option.value }"
                    @click="item.status = option.value"
                    class="pa-0 py-1 ma-0 d-flex justify-center aling-center"
                    :style="{
                      backgroundColor: item.status === option.value ? '#0065FC' : '',
                      borderColor: item.status === option.value ? '#0065FC' : 'silver',
                      color: item.status === option.value ? '#e5f2fe' : '',
                    }"
                  >
                    <v-card-text class="pa-0 text-caption ma-0">
                      {{ option.label }}
                    </v-card-text>
                  </div>
                </v-container>
              </v-card-text>
            </template> -->
            <!-- <template v-slot:header.edit="{ header }">
              <v-container
                class="pa-0 d-flex justify-space-between align-center ma-0 cursor-pointer"
              >
                <v-card-text class="pa-0 ma-0 text-body-2">{{ header.text }}</v-card-text>
                <v-icon small color="gray">mdi-trash-can-outline</v-icon>
              </v-container>
            </template>
            <template v-slot:item.edit="{ item, index }">
              <v-container class="pa-0 d-flex justify-space-between align-center ma-0">
                <v-icon
                  v-if="!iconLoading"
                  small
                  class="pa-0 mr-4 ma-0"
                  :class="{
                    'cursor-pointer': item.status !== 'default',
                    'icon-disabled': item.status === 'default',
                  }"
                  color="#595a5c"
                  :disabled="item.status === 'default'"
                  @click="item.status !== 'default' && getItemsById(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-progress-circular
                  v-if="iconLoading"
                  class="pa-0 ma-0 mr-3"
                  indeterminate
                  size="16"
                  width="2"
                  color="#595a5c"
                />
                <v-icon
                  small
                  class="pa-0 ma-0"
                  :class="{
                    'cursor-pointer': item.status !== 'default',
                    'icon-disabled': item.status === 'default',
                  }"
                  color="#595a5c"
                  v-if="!trashLoading"
                  :disabled="item.status === 'default'"
                  @click="item.status !== 'default' && openPermission(item)"
                >
                  mdi-trash-can-outline
                </v-icon>
                <v-progress-circular
                  v-if="trashLoading"
                  class="pa-0 ma-0"
                  indeterminate
                  size="16"
                  width="2"
                  color="#595a5c"
                />
              </v-container>
            </template> -->
          </v-data-table>
        </div>
        <v-container class="pa-0 d-flex justify-space-between mt-3">
          <div class="mb-2"></div>
          <div class="d-flex align-center gap-1">
            <v-btn dense color="primary" height="32" @click="close()">
              {{ $t("add_to_table") }}
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
    <!--add new salery items Dialog-->
    <v-dialog
      v-if="NewSaleryFactorDialog"
      v-model="NewSaleryFactorDialog"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      max-width="400"
    >
      <v-card class="pa-5 ma-0">
        <v-container
          class="pa-0 mb-6 d-flex justify-space-between"
          :class="{ 'pa-5': isMobile }"
        >
          <v-card-text v-if="!isEditing" class="ma-0 pa-0 text-body-1">{{
            $t("new_salery_factors")
          }}</v-card-text>
          <!-- <v-card-text v-if="isEditing" class="ma-0 pa-0 text-body-1">
            {{ $t("edit") }} ( {{ changeTitle }} )
          </v-card-text> -->
          <v-icon class="pa-0 ma-0" @click="NewSaleryFactorDialog = false"
            >mdi-close</v-icon
          >
        </v-container>
        <!--status-->
        <v-container
          class="pa-0 d-flex justify-space-between mb-5"
          :class="{ 'pa-5': isMobile }"
        >
          <v-card-text class="ma-0 pa-0 text-body-1">{{ $t("status") }}</v-card-text>
          <v-container
            class="pa-0 ma-0 d-flex justify-center aling-center wrapperOption"
            style="width: auto"
          >
            <div
              v-for="(item, index) in Options"
              :key="index"
              class="pa-0 py-2 ma-0 d-flex justify-center aling-center"
              @click="selectOption(item)"
              :style="{
                'background-color': selectedOption == item.value ? '#0065FC' : '',
                'border-color': selectedOption == item.value ? '#0065FC' : 'silver',
                color: selectedOption == item.value ? '#e5f2fe' : '',
              }"
            >
              <v-card-text class="pa-0 text-caption">
                {{ item.label }}
              </v-card-text>
            </div>
          </v-container>
        </v-container>
        <!-- Conditional fields-->
        <v-container class="pa-0 ma-0 d-flex flex-column gap-3">
          <v-container class="pa-0 ma-0 mb-4">
            <v-text-field
              v-model="title"
              :label="$t('caption')"
              outlined
              clearable
              dense
              :rules="[(v) => !!v || $t('is-required')]"
          /></v-container>
          <v-container class="pa-0 ma-0 mb-4">
            <FlexibleAutocomplete
              v-model="agentGroup"
              title="Agent_Group"
              type="level"
              :currency="currencyId"
              :multiple="false"
              :fetchData="fetchApi"
              return-object
            />
          </v-container>
          <v-container v-if="isBenefit || isDeduction" class="pa-0 ma-0 mb-3">
            <FlexibleAutocomplete
              v-model="contractType"
              :key="'contract-' + agentGroup?.id"
              title="kind"
              type="contract_type"
              :currency="currencyId"
              :multiple="false"
              :fetchData="fetchApi"
            />
          </v-container>
          <v-container v-if="isPerformance" class="pa-0 ma-0 mb-3">
            <FlexibleAutocomplete
              v-model="performanceType"
              :key="'performance-' + agentGroup?.id"
              title="performance_type"
              type="performance_type"
              :currency="currencyId"
              :multiple="false"
              :fetchData="fetchApi"
            />
          </v-container>
          <v-container v-if="isBenefit" class="pa-0 ma-0 d-flex">
            <v-card-text class="ma-0 pa-0 text-body-2 mt-1"
              >{{ $t("benefit") }} {{ $t("nonCash") }}</v-card-text
            >
            <v-checkbox v-model="nonCashBenefit" dense hide-details class="ma-0 pa-0" />
          </v-container>
          <v-container v-if="isBenefit" class="pa-0 ma-0">
            <FlexibleAutocomplete
              v-model="calculateType"
              title="Tax_Calculation_Method"
              type="calculate_type"
              :currency="currencyId"
              :multiple="false"
              :fetchData="fetchApi"
            />
          </v-container>

          <v-container class="pa-0 d-flex justify-space-between ma-0">
            <div class="mb-6"></div>
            <div v-if="!isEditing" class="d-flex align-center gap-1 pa-0 mt-5 ma-0">
              <v-btn
                :loading="loading"
                dense
                color="primary"
                height="32"
                @click="addItemsToList()"
              >
                {{ $t("confirm") }}
              </v-btn>
            </div>
            <div v-if="isEditing" class="d-flex align-center gap-1 pa-0 mt-5 ma-0">
              <v-btn
                :loading="loading"
                dense
                color="primary"
                height="32"
                @click="updateItems()"
              >
                {{ $t("edit") }}
              </v-btn>
            </div>
          </v-container>
        </v-container>
      </v-card>
    </v-dialog>
    <!--permison dialog-->
    <v-dialog
      v-model="askPerm"
      :fullscreen="isMobile"
      :hide-overlay="isMobile"
      width="300"
    >
      <v-card class="pa-5">
        <v-container class="pa-0 d-flex justify-center">
          <v-icon size="45" color="warning">mdi-alert-circle-outline</v-icon>
        </v-container>
        <v-card-text class="pa-0 text-body-1 text-center my-3">
          {{ $t("are-you-sure-delete-this-case") }}
        </v-card-text>
        <v-container class="pa-0 ma-0 d-flex flex-column align-center gap-2 mb-6">
          <v-container class="pa-0 ma-0 d-flex gap-1 align-center">
            <v-card-text class="pa-0 text-body-1"> {{ $t("caption") }}: </v-card-text>
            <v-card-text class="pa-0 text-body-1" style="color: gray">
              {{ detailPerm?.name ? detailPerm.name : $t("haveNot") }}
            </v-card-text>
          </v-container>
          <v-container class="pa-0 ma-0 d-flex gap-1 align-center">
            <v-card-text class="pa-0 text-body-1"> {{ $t("group") }}: </v-card-text>
            <v-card-text class="pa-0 text-body-1" style="color: gray">
              {{ detailPerm?.level ? detailPerm.level : $t("haveNot") }}
            </v-card-text>
          </v-container>
          <v-container class="pa-0 ma-0 d-flex gap-1 align-center">
            <v-card-text class="pa-0 text-body-1"> {{ $t("type") }}: </v-card-text>
            <v-card-text class="pa-0 text-body-1" style="color: gray">
              {{ detailPerm?.type ? detailPerm.type : $t("haveNot") }}
            </v-card-text>
          </v-container>
        </v-container>
        <v-container class="pa-0 d-flex justify-center align-center gap-2">
          <v-btn :loading="loading" color="primary" height="32" @click="handleAccept">
            {{ $t("yes") }}
          </v-btn>
          <v-btn color="error" height="32" @click="askPerm = false">
            {{ $t("no") }}
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import mixin from "@/Mixins/mixin";
import FlexibleAutocomplete from "../../../../components/general/patial/FlexibleAutocomplete.vue";

export default {
  name: "SaleryfactorsDialog",
  props: {
    saleryOperationsOptions: {
      type: [String, Object, Array],
      default: [],
    },
    openDialog: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixin],
  components: {
    FlexibleAutocomplete,
  },
  data() {
    return {
      activeTab: "tab1",
      selectedOption: "active",
      fixedNumberOfDay: null,
      search: null,
      workshopID: null,
      agentGroup: null,
      contractType: null,
      performanceType: null,
      calculateType: null,
      currencyId: null,
      _id: null,
      title: null,
      detailPerm: null,
      compositeDialog: false,
      NewSaleryFactorDialog: false,
      nonCashBenefit: false,
      loading: false,
      askPerm: false,
      iconLoading: false,
      trashLoading: false,
      tableLoading: false,
      isEditing: false,
      changeTitle: null,
      compositeTableHeaders: [],
      compositeItems: [],
    };
  },

  computed: {
    isTab3Active() {
      if (this.activeTab == 2) {
        return true;
      } else {
        return false;
      }
    },
    isDeduction() {
      if (!this.agentGroup) return false;
      return this.agentGroup.id === "deductions";
    },
    isBenefit() {
      if (!this.agentGroup) return false;
      return this.agentGroup.id === "benefit";
    },
    isPerformance() {
      if (!this.agentGroup) return false;
      return this.agentGroup.id === "performance";
    },
    Options() {
      return [
        { label: this.$t("active"), value: "active" },
        { label: this.$t("deactive"), value: "deactive" },
      ];
    },
    filteredItems() {
      if (!this.search) return this.compositeItems;
      const searchArray = this.search.toLowerCase().trim();
      return this.compositeItems.filter(
        (item) =>
          (item.name && item.name.toLowerCase().includes(searchArray)) ||
          (item.level && item.level.toLowerCase().includes(searchArray))
      );
    },
  },
  watch: {
    saleryOperationsOptions: {
      deep: true,
      handler(newVal) {
        this.workshopID = newVal.workshop_id;
        this.getItems();
      },
    },
    openDialog: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.compositeDialog = true;
        }
      },
    },
    isEditing: {
      deep: true,
      handler(newVal) {
        if (!newVal) {
          this.title = null;
          this.selectedOption = "active";
          this.agentGroup = null;
          this.contractType = null;
          this.calculateType = null;
          this.performanceType = null;
          this.nonCashBenefit = false;
        }
      },
    },
    compositeDialog: {
      deep: true,
      handler(newVal) {
        if (newVal) {
          this.$emit("close-dialog");
        }
      },
    },
    NewSaleryFactorDialog: {
      deep: true,
      handler(newVal) {
        if (!newVal) {
          this.title = null;
          this.selectedOption = "active";
          this.agentGroup = null;
          this.contractType = null;
          this.calculateType = null;
          this.performanceType = null;
          this.nonCashBenefit = false;
        }
      },
    },
    agentGroup(newVal) {
      if (!newVal) {
        this.contractType = null;
        this.calculateType = null;
        this.performanceType = null;
        this.nonCashBenefit = false;
        return;
      }
      if (newVal.id === "performance") {
        this.contractType = null;
        this.calculateType = null;
        this.nonCashBenefit = false;
      }
      if (newVal.id === "deductions") {
        this.performanceType = null;
        this.calculateType = null;
        this.nonCashBenefit = false;
      }
      if (newVal.id === "benefit") {
        this.performanceType = null;
      }
    },
  },
  mounted() {
    const query = this.$route.query || {};
    if (Object.keys(query).length > 0) {
      this.getItems();
    }
  },
  beforeMount() {
    this.compositeTableHeaders = [
      {
        text: this.$t("#"),
        value: "id",
        sortable: false,
        width: 20,
      },
      {
        value: "incentive_benefit",
        sortable: false,
        width: 15,
      },
      {
        text: this.$t("name"),
        value: "name",
        sortable: false,
      },
      {
        text: this.$t("Severanc_Days"),
        value: "type",
        sortable: false,
        width: 150,
      },
      {
        text: this.$t("Severanc_Price"),
        value: "type",
        sortable: false,
        width: 150,
      },
      // {
      //   text: this.$t("type_of_tax_calc"),
      //   value: "tax_type",
      //   sortable: false,
      // },
      // {
      //   text: this.$t("status"),
      //   value: "status",
      //   sortable: false,
      //   width: 38,
      // },
      // {
      //   text: this.$t("edit"),
      //   value: "edit",
      //   sortable: false,
      // },
    ];
  },
  methods: {
    fetchApi(payload) {
      const mockDataSets = {
        level: [
          { id: "benefit", name: "مزایا", type: "level" },
          { id: "deductions", name: "کسورات", type: "level" },
          { id: "performance", name: "کارکردی", type: "level" },
        ],
        calculate_type: [
          { id: "fixed", name: "ثابت" },
          { id: "Stepped", name: "پلکانی" },
        ],
        contract_type: [
          { id: "fixed_contract", name: "قراردادی ثابت" },
          { id: "manual", name: "ورودی محاسباتی" },
          { id: "calculate", name: "ورودی دستی" },
        ],
        performance_type: [
          { id: "day", name: "روز" },
          { id: "hourMin", name: "دقیقه/ساعت" },
          { id: "number", name: "عددی" },
          { id: "percent", name: "درصدی" },
        ],
      };
      const selectedList = mockDataSets[payload.type] || [];
      const filtered = payload.search
        ? selectedList.filter((item) =>
            item.name.toLowerCase().includes(payload.search.toLowerCase())
          )
        : selectedList;

      return Promise.resolve({
        items: filtered,
        hasMore: false,
      });
    },
    normalizeStatus(status) {
      if (status === "active") return "active";
      if (status === "default") return "default";
      return "deactive";
    },
    selectOption(item) {
      this.selectedOption = item.value;
    },
    openNewSaleryFactor() {
      this.NewSaleryFactorDialog = true;
    },
    close() {
      this.compositeDialog = false;
      this.$emit("close-dialog");
    },

    getItems() {
      var app = this;
      app.tableLoading = true;
      const id_ = app.$route.query.id ? app.$route.query.id : 0;
      const workshopId = this.workshopID || app.$route.query.hrm_workshop_id;
      app.$axios
        .get(app.$endpoint + "salary/" + id_, {
          params: {
            workshop: workshopId,
          },
        })
        .then((response) => {
          app.compositeItems = response.data.configs.name;
        })
        .catch((err) => {
          app.tableLoading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.tableLoading = false;
        });
    },
    getItemsById(val) {
      var app = this;
      app.iconLoading = true;
      let itemsID = val?.id;
      app._id = val?.id;
      app.isEditing = true;
      app.$axios
        .get(app.$endpoint + "salary-factor/" + itemsID)
        .then((response) => {
          app.changeTitle = response.data?.name || null;
          app.title = response.data?.name || null;
          app.selectedOption = response.data?.status || "active";
          app.agentGroup = response.data?.level
            ? { id: response.data.level, name: response.data.level, type: "level" }
            : null;
          app.contractType = response.data?.type
            ? { id: response.data.type, name: response.data.type }
            : null;
          app.calculateType = response.data?.tax_type
            ? { id: response.data.tax_type, name: response.data.tax_type }
            : null;
          app.performanceType = response.data?.function_type
            ? { id: response.data.function_type, name: response.data.function_type }
            : null;
          app.nonCashBenefit = response.data?.incentive_benefit || false;
          app.NewSaleryFactorDialog = true;
        })
        .catch((err) => {
          app.iconLoading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.iconLoading = false;
        });
    },
    addItemsToList() {
      var app = this;
      app.loading = true;
      app.$axios
        .post(this.$endpoint + "salary-factor", {
          name: app.title,
          status: app.selectedOption,
          level: app.agentGroup?.id ?? null,
          type: app.contractType?.id ?? null,
          function_type: app.performanceType?.id ?? null,
          tax_type: app.calculateType?.id ?? null,
          incentive_benefit: app.nonCashBenefit ? 1 : 0,
        })
        .then((response) => {
          app.title = null;
          app.selectedOption = "active";
          app.agentGroup = null;
          app.contractType = null;
          app.calculateType = null;
          app.performanceType = null;
          app.nonCashBenefit = false;
          app.getItems();
          app.NewSaleryFactorDialog = false;
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    updateItems() {
      var app = this;
      app.loading = true;
      let itemsID = app._id;
      app.$axios
        .put(this.$endpoint + "salary-factor/" + itemsID, {
          name: app.title,
          status: app.selectedOption,
          level: app.agentGroup?.id ?? null,
          type: app.contractType?.id ?? null,
          function_type: app.performanceType?.id ?? null,
          tax_type: app.calculateType?.id ?? null,
          incentive_benefit: app.nonCashBenefit ? 1 : 0,
        })
        .then((response) => {
          app.title = null;
          app.selectedOption = "active";
          app.agentGroup = null;
          app.contractType = null;
          app.calculateType = null;
          app.performanceType = null;
          app.nonCashBenefit = false;
          app.getItems();
          app.NewSaleryFactorDialog = false;
          app.isEditing = false;
        })
        .catch((err) => {
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.loading = false;
        });
    },
    deleteAction() {
      var app = this;
      let itemsID = app._id;
      app.trashLoading = true;
      app.loading = true;
      app.$axios
        .delete(app.$endpoint + "salary-factor/" + itemsID)
        .then((response) => {})
        .catch((err) => {
          app.trashLoading = false;
          app.loading = false;
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.getItems();
          app.trashLoading = false;
          app.loading = false;
          this.askPerm = false;
        });
    },
    openPermission(val) {
      this._id = val?.id;
      this.askPerm = true;
      this.detailPerm = val;
    },
    handleAccept() {
      this.deleteAction();
    },
  },
};
</script>
<style scoped>
::v-deep .v-messages.theme--light {
  display: none !important;
}
::v-deep .v-label .v-label--active {
  right: -28px !important;
}
.filters-row .v-input {
  max-width: 100%;
}
.icon-container {
  position: rela vcZtive;
}
.icon-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
::v-deep .custom-annual-tabs > .v-tabs-bar {
  height: 30px !important;
  min-height: 30px;
}
.table-wrapper {
  position: relative;
}
.table-loading-line {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
}
.wrapper {
  display: flex;
  border: 1px solid #cfcfcf;
  border-radius: 4px;
  overflow: hidden;
  width: max-content;
  direction: rtl;
}
.wrapper > div {
  cursor: pointer;
  width: 60px;
}
.wrapperOption {
  display: flex;
  border: 1px solid #cfcfcf;
  border-radius: 4px;
  overflow: hidden;
  width: max-content;
  direction: rtl;
}
.wrapperOption > div {
  cursor: pointer;
  width: 75px;
}
.wrapper > div:last-child {
  border-right: 1px solid silver !important;
}
::v-deep .v-data-table.composite {
  border: 1px solid silver;
}
::v-deep .v-data-table.composite .v-data-table-header {
  background-color: #d9d9d9;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > thead > tr > th {
  font-size: 8.3pt;
  border-left: 1px solid silver;
  color: black;
  height: 40px !important;
  background-color: #eeeeee;
}
::v-deep .v-data-table.composite > .v-data-table__wrapper > table > tbody > tr > td {
  border-left: 1px solid silver;
  padding-right: 4px;
}
.checkbox-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding-bottom: 12px;
}
.cursor-pointer {
  cursor: pointer;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background-color: silver;
}
::v-deep .v-data-table.composite .v-data-table__wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}
::v-deep .v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none;
}
.table-input {
  display: flex;
  align-items: center;
  height: 100%;
}

::v-deep .table-text-field .v-input__control {
  min-height: 28px !important;
}

::v-deep .table-text-field .v-input__slot {
  min-height: 28px !important;
}

::v-deep .table-text-field input {
  height: 28px !important;
  padding: 0 6px !important;
  font-size: 12px;
}
</style>
